module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/efb73f60306820afdf07cc9c949c8abd.jpg";